import { TranslateService } from '@ngx-translate/core';
import { TypeMessage } from './../core/services/notification.service';
import { Store, Select } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ControlPanelStore } from './control-panel.store';
import { Observable, Subject } from 'rxjs';
import { ControlPanel } from './control-panel.actions';
import { Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { NotificationService } from 'src/core/services/notification.service';
import { LoaderService } from 'src/core/layouts/loader/loader.service';
import { AuthenticateDto, AuthenticateFromMaslDto, ChangePasswordDto, EidDataRecordDto, PanelSection, SetPasswordWithTokenRequestDto } from 'src/api/models';
import { EnvService } from 'src/environments/environment';
import { WebApiSignalRServerMethod, WebApiSignalRClientMethod } from 'src/api/models';
import { PDAVisites } from 'src/modules/pda/visites/state/pda-visites.actions';
import { EventEmitter } from 'protractor';

@Injectable({ providedIn: 'root' })
export class ControlPanelService {

  TenantId: string = null;
  SiteId: string = null;

  @Select(ControlPanelStore.userId$)
  userId$: Observable<number>;
  UserId: number = null;

  @Select(ControlPanelStore.transporteurId$)
  transporteurId$: Observable<number>;
  TransporteurId: number = null;

  @Select(ControlPanelStore.isLoggedIn$)
  isLoggedIn$: Observable<boolean>;

  @Select(ControlPanelStore.permissions$)
  permissions$: Observable<string[]>;
  permissions: string[]; // Current user permissions

  @Select(ControlPanelStore.language$)
  language$: Observable<string>;
  language: string;  // Current user language

  @Select(ControlPanelStore.authToken$)
  token$: Observable<string>;
  token: string;

  /*@Select(ControlPanelStore.azureParams$)
  azureParams$: Observable<ParametresAzureDto>;
  azureParams: ParametresAzureDto;*/

  @Select(ControlPanelStore.navigationItems$)
  navigationItems$: Observable<PanelSection[]>;

  @Select(ControlPanelStore.error$) error$: Observable<any>;

  requestHeader = {};

  webapiSignalRConnection: signalR.HubConnection = null;

  changeMenuIsOpen = new Subject<boolean>();

  constructor(
    private store: Store,
    private router: Router,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private envService: EnvService,
    private loaderService: LoaderService
  ) {
    this.isLoggedIn$.subscribe(l => {
      if (l === false) {
        this.router.navigate(['/auth', 'login']);
      }
    });

    this.language$.subscribe(l => this.language = l);
    this.permissions$.subscribe(p => this.permissions = p);
    this.userId$.subscribe(u => this.UserId = u );
    this.transporteurId$.subscribe(t => this.TransporteurId = t);
    this.error$.subscribe(e => {
      if (e != null) {
        console.error('ControlPanelService error:', e);
      }
    });

    this.token$.subscribe(t => {
      this.token = t;
      this.requestHeader = { Authorization: 'Bearer ' + t };

      // this.DisconnectSignalR(this.webapiSignalRConnection);

      if (t) {
        this.webapiSignalRConnection = this.ConnectSignalR(envService.apiUrl + '/signalr/webapi');
      }
    });
  }

  login(login: any) {
    this.store.dispatch(new ControlPanel.Login(login));
  }

  loginPP(login: AuthenticateDto) {
    this.store.dispatch(new ControlPanel.LoginPP(login));
  }

  loginFromCode(login: any) {
    this.store.dispatch(new ControlPanel.LoginFromCode(login));
  }

  loginFromMsal(login: AuthenticateFromMaslDto) {
    this.store.dispatch(new ControlPanel.LoginFromMSAL(login));
  }

  logout() {
    this.loaderService.FinishLoad();

    // console.log('-----> ', this.webapiSignalRConnection);

    if(this.webapiSignalRConnection?.state == signalR.HubConnectionState.Disconnected) {
      this.store.dispatch(new ControlPanel.SetToken(null));
    } else {
      this.DisconnectSignalR(this.webapiSignalRConnection);
    }

    this.store.dispatch(new ControlPanel.Logout());
  }

  // See list of permissions in api/models/permissions-core.ts and api/models/permissions-pbx.ts
  // (import PermissionsCore and PermissionsPbx)
  HavePermission(perm: string) {
    return this.permissions.find(p => p === perm) ? true : false;
  }

  ConnectSignalR(url: string): signalR.HubConnection {
    // this.notificationService.displayMessage(TypeMessage.info, this.translateService.instant('SignalR.Connecting'));
    // Configure Signalr
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(url, { accessTokenFactory: () => this.token })
      // .configureLogging(signalR.LogLevel.Trace)
      .withAutomaticReconnect()
      .build();

    connection.onclose((error: Error) => {
      // console.log('SignalR connection closed');
      // this.notificationService.displayMessage(TypeMessage.warning, this.translateService.instant('SignalR.Disconnected'));
      this.store.dispatch(new ControlPanel.UpdateSignalRStatus(false));
      this.store.dispatch(new ControlPanel.SetToken(null));
    });

    connection.onreconnecting((error: Error) => {
      // console.log('SignalR connection reconnecting');
    });

    connection.onreconnected((connectionId: string) => {
      // console.log('SignalR connection reconnected');
      // this.notificationService.displayMessage(TypeMessage.info, this.translateService.instant('SignalR.ConnectionRestored'));
      this.store.dispatch(new ControlPanel.UpdateSignalRStatus(true));
      connection.invoke(WebApiSignalRServerMethod.Identify, 'web/angular', 'GRCP Control Panel', -1);
    });

    connection.start()
      .then(() => {
        // console.log('SignalR connection succeeded');
        // this.notificationService.displayMessage(TypeMessage.success, this.translateService.instant('SignalR.Connected'));
        this.store.dispatch(new ControlPanel.UpdateSignalRStatus(true));
        connection.invoke(WebApiSignalRServerMethod.Identify, 'web/angular', 'GRCP Control Panel', -1);

        connection.on(WebApiSignalRClientMethod.NotifyEIdCard, (card : EidDataRecordDto) => {
          console.log('Received eId card notification: ', card);
          this.store.dispatch(new PDAVisites.SetEidRead(card));
        })
      })
      .catch(err => {
        // console.log('SignalR connection failed');
        // this.notificationService.displayMessage(TypeMessage.error, this.translateService.instant('SignalR.ConnectionError'));
        this.store.dispatch(new ControlPanel.UpdateSignalRStatus(false));
      });

    return connection;
  }

  DisconnectSignalR(connection: signalR.HubConnection) {
    if (connection && connection.state !== signalR.HubConnectionState.Disconnected) {
      // this.notificationService.displayMessage(TypeMessage.info, this.translateService.instant('SignalR.Disconnected'));
      connection.stop();
      this.store.dispatch(new ControlPanel.UpdateSignalRStatus(false));
    }
  }

  passwordForgotten(email: string) {
    this.store.dispatch(new ControlPanel.PasswordForgotten(email));
  }

  resetPassword(token: string, password: string) {
    this.store.dispatch(new ControlPanel.ResetPassword(token, password));
  }

  resetPasswordPersonnePhysique(token: string, password: string) {
    this.store.dispatch(new ControlPanel.ResetPasswordPersonnePhysique(token, password));
  }

  changePasswordPersonnePhysique(login: string, requestDTO: ChangePasswordDto) {
    this.store.dispatch(new ControlPanel.ChangePersonnePhysiquePassword(login, requestDTO));
  }


}
